
const GetBatchDeliveryManagerLog = `
  query Query($id: String!) {
    batchDeliveryManagerLog(id: $id) {
      id
      businessLog {
        type
        message
        timestamp
      }
      failed
      region
      timestamp
    }
  }
`

const GetBatchDeliveryManagerLogs = `
  query Query($count: Int, $cursor: String, $filterConfig: BatchDeliveryManagerFilterConfigInput) {
    batchDeliveryManagerLogs(first: $count, after: $cursor, filterConfig: $filterConfig) {
      pageInfo {
        hasNextPage 
      }
      edges {
        cursor
        node {
          id
          failed
          region
          timestamp
        }
      }
    }
  }  
`

module.exports = {
  GetBatchDeliveryManagerLog,
  GetBatchDeliveryManagerLogs,
}
